export default __webpack_public_path__ + "static/media/login-bg.5e3a46ec.jpg";